import {Resource} from '@raison/types';
import {selectFinancesState} from '~/redux/finances/financesPrimitives';
import {FinancialData} from '~/redux/finances/financesReducer';

export const selectFinancesResource = (state: AppModel): Resource<FinancialData> => {
    const finances = selectFinancesState(state);
    switch (finances.status) {
        case 'initial':
            return Resource.from({isUninitialized: true});
        case 'trigger':
            if (finances.data) {
                return Resource.from({isSuccess: true, data: finances.data, isFetching: true});
            } else {
                return Resource.from({isLoading: true});
            }
        case 'success':
            return Resource.from({isSuccess: true, data: finances.data, isFetching: false});
        case 'failure':
            return Resource.from({isError: true, error: finances.error});
    }
};
